import { render, staticRenderFns } from "./AccreditationPage.vue?vue&type=template&id=02333516"
import script from "./AccreditationPage.vue?vue&type=script&lang=js"
export * from "./AccreditationPage.vue?vue&type=script&lang=js"
import style0 from "./AccreditationPage.vue?vue&type=style&index=0&id=02333516&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports